import { render, staticRenderFns } from "./refund.vue?vue&type=template&id=3848d8fa&scoped=true"
import script from "./refund.vue?vue&type=script&lang=ts"
export * from "./refund.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3848d8fa",
  null
  
)

export default component.exports